import { render, staticRenderFns } from "./params.vue?vue&type=template&id=a045b542&"
import script from "./params.vue?vue&type=script&lang=js&"
export * from "./params.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a045b542')) {
      api.createRecord('a045b542', component.options)
    } else {
      api.reload('a045b542', component.options)
    }
    module.hot.accept("./params.vue?vue&type=template&id=a045b542&", function () {
      api.rerender('a045b542', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/page-cache/params.vue"
export default component.exports